var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivecoach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0083 45.4119C35.401 45.4119 45.4473 35.3656 45.4473 22.9729C45.4473 10.5802 35.401 0.533936 23.0083 0.533936C10.6156 0.533936 0.569336 10.5802 0.569336 22.9729C0.569336 35.3656 10.6156 45.4119 23.0083 45.4119Z",
    fill: "#1976d2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33384_16940)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2592 33.8184C17.1033 33.8184 15.0725 32.9904 13.5572 31.4751C12.0262 29.9598 11.1982 27.9446 11.1982 25.8043C11.1982 23.6641 12.0262 21.6489 13.5572 20.1492C15.0725 18.6339 17.1033 17.7903 19.2592 17.7903H25.5079C25.7267 17.7903 25.8985 17.9465 25.9454 18.1496L26.2266 19.3056H28.6636L28.9448 18.1496C28.9916 17.9465 29.1791 17.7903 29.3978 17.7903H33.5064V23.7266L27.1795 24.6015C27.2264 24.992 27.2576 25.3982 27.2576 25.8043C27.2732 30.2254 23.6802 33.8184 19.2592 33.8184ZM34.0375 17.7903H35.8497C36.0996 17.7903 36.3183 18.009 36.3183 18.2589V22.9455C36.3183 23.1799 36.1465 23.3829 35.9122 23.4142L34.0375 23.6641V17.7903ZM19.2592 29.0381C21.0401 29.0381 22.4773 27.5852 22.4773 25.8043C22.4773 24.0234 21.0401 22.5862 19.2592 22.5862C17.447 22.5862 16.0254 23.9922 16.0254 25.8043C16.0254 27.6165 17.447 29.0381 19.2592 29.0381ZM19.2592 23.1017C20.7433 23.1017 21.9618 24.3203 21.9618 25.8043C21.9618 27.3041 20.7433 28.5069 19.2592 28.5069C17.7438 28.5069 16.5566 27.3197 16.5566 25.8043C16.5566 24.289 17.7438 23.1017 19.2592 23.1017Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4296 15.0876C27.164 15.0876 26.9609 14.8845 26.9609 14.6189V12.6505C26.9609 12.385 27.164 12.1819 27.4296 12.1819C27.6795 12.1819 27.8983 12.385 27.8983 12.6505V14.6189C27.8983 14.8845 27.6795 15.0876 27.4296 15.0876Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8663 16.228C29.7726 16.228 29.6789 16.2124 29.6008 16.1499C29.382 15.9937 29.3352 15.7125 29.4914 15.4938L30.7412 13.7285C30.8818 13.5254 31.1786 13.4785 31.3817 13.6191C31.6004 13.7754 31.6472 14.0566 31.491 14.2753L30.2569 16.0405C30.1631 16.1655 30.0225 16.228 29.8663 16.228Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0855 16.228C24.9449 16.228 24.7887 16.1655 24.6949 16.0405L23.4452 14.2753C23.3046 14.0565 23.3514 13.7597 23.5701 13.6191C23.7732 13.4629 24.07 13.5254 24.2106 13.7285L25.4604 15.4938C25.6166 15.7125 25.5697 16.0093 25.351 16.1499C25.2729 16.2124 25.1792 16.228 25.0855 16.228Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0259 28.5068H10.1513C9.8857 28.5068 9.68262 28.3037 9.68262 28.0381V23.5702C9.68262 23.3046 9.8857 23.1016 10.1513 23.1016H12.0259C12.2915 23.1016 12.4946 23.3046 12.4946 23.5702C12.4946 23.8358 12.2915 24.0389 12.0259 24.0389H10.6199V27.5694H12.0259C12.2915 27.5694 12.4946 27.7881 12.4946 28.0381C12.4946 28.3037 12.2915 28.5068 12.0259 28.5068Z",
    fill: "#FCFCFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.4294 18.6337C26.6952 18.6337 26.0703 17.9776 26.0703 17.2278C26.0703 16.4623 26.6639 15.8687 27.4294 15.8687C28.2261 15.8687 28.8354 16.4467 28.8354 17.2278C28.8354 17.9932 28.1949 18.6337 27.4294 18.6337Z",
    fill: "#FCFCFC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33384_16940"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.6667,
    height: 26.6667,
    fill: "white",
    transform: "translate(9.66699 9.66675)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivecoach);
export default __webpack_public_path__ + "static/media/activecoach.1805257392c11b12b04ec32fcd557b15.svg";
export { ForwardRef as ReactComponent };